module.exports = __webpack_public_path__ + "893b7d66d750f8124729c15ec0bc9321.ttf";


//////////////////
// WEBPACK FOOTER
// ./app/assets/fonts/MyriadPro-Bold.ttf
// module id = 155
// module chunks = 0